import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { BubbleIcon } from '@/components/Icons/Bubble';
import styles from './CustomIcon.module.scss';
export const CustomIcon = ({ onClick, imgUrl, theme, size, ariaLabel, }) => {
    const [isBroken, setIsBroken] = useState(false);
    const handleKeyUp = useCallback((e) => {
        if (e.key === 'Enter') {
            onClick();
        }
    }, [onClick]);
    return !isBroken ? (_jsx("div", { className: styles.container, onClick: onClick, onKeyUp: handleKeyUp, tabIndex: 0, "aria-label": ariaLabel, role: "button", style: { width: size, height: size }, children: _jsx("img", { src: imgUrl, alt: "custom icon", className: styles.img, onError: () => setIsBroken(true) }) })) : (_jsx(BubbleIcon, { theme: theme, size: size, onClick: onClick }));
};
